import { NeqTableRequest } from "@sharedcommon/components/table/neq-table-request.model";
import { SharedSortOrder } from "@sharedcommon/model/shared-sort-order.model";

export class SortOrderUtil {
  /**
   * Convert the sort part of a request from table to a sort understandable by MatrixNutri and shared API
   * @param tableRequest the request from a table
   * @param fieldMapping the look up table between the column name of the table and the attribute name of the filter dto
   * @returns the converted sort from the request from table
   */
  static returnSortDtoFromTableRequest(tableRequest: NeqTableRequest, fieldMapping?: Map<string, string[]>): SharedSortOrder[] {
    const sortOrders: SharedSortOrder[] = [];
    if (tableRequest.tri && tableRequest.tri.length > 0) {
        tableRequest.tri.forEach(neqTri => {
            const field = neqTri.field;
            if (fieldMapping?.has(neqTri.field)) {
                fieldMapping.get(neqTri.field)
                    .forEach(mappedField => sortOrders.push({
                        field: mappedField,
                        asc: neqTri.asc
                    }));
            } else {
                sortOrders.push({
                    field: field,
                    asc: neqTri.asc
                });
            }
        });
    }
    return sortOrders;
  }
}
